type AccountLabel = {
  type: 'bank' | 'platform' | 'cash'
  accountHolder: string
  bankName: string | null
  accountNo: string | null
}

export function formatAccountLabel(account: AccountLabel) {
  const typeLabel = { bank: '银行账户', platform: '收款平台', cash: '现金账户' }[account.type]
  return [
    account.accountHolder,
    account.bankName || typeLabel,
    account.accountNo ? `尾号 ${account.accountNo.replace(/\s/g, '').slice(-4)}` : null
  ]
    .filter(Boolean)
    .join(' · ')
}
